import { handleGetRequest, handlePatchRequest } from "./http.service";

export interface CsrTicket {
  _id: string;
  ticketNumber: string;
  subject: string;
  description: string;
  category: string;
  priority: string;
  status: "open" | "in_progress" | "resolved" | "closed";
  email?: string;
  name?: string;
  userId?: { firstName: string; lastName: string; email: string };
  assignedTo?: { _id: string; firstName?: string; lastName?: string; email: string };
  assignedAt?: string;
  notes?: string;
  /** Full history. `notes` is only ever the most recent entry. */
  comments?: {
    body: string;
    authorName?: string;
    createdAt: string;
  }[];
  resolvedAt?: string;
  slaDueAt: string;
  slaBreached: boolean;
  createdAt: string;
}

export interface CsrSummary {
  total: number;
  open: number;
  inProgress: number;
  resolved: number;
  breached: number;
  unassigned: number;
}

/** The API paginates this list; it used to return every ticket at once. */
export interface CsrTicketPage {
  page: number;
  limit: number;
  total: number;
  data: CsrTicket[];
}

export const getCsrSummary = async () =>
  handleGetRequest<CsrSummary>("/csr/summary");

export const getAllCsrTickets = async (params?: {
  status?: string;
  priority?: string;
  slaBreached?: boolean;
  unassigned?: boolean;
  page?: number;
  limit?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.status) qs.set("status", params.status);
  if (params?.priority) qs.set("priority", params.priority);
  if (params?.slaBreached !== undefined)
    qs.set("slaBreached", String(params.slaBreached));
  if (params?.unassigned) qs.set("unassigned", "true");
  qs.set("page", String(params?.page ?? 1));
  qs.set("limit", String(params?.limit ?? 50));
  return handleGetRequest<CsrTicketPage>(`/csr?${qs}`);
};

export const assignCsrTicket = async (id: string, assignedTo: string | null) =>
  handlePatchRequest<{ assignedTo: string | null }, CsrTicket>(
    `/csr/${id}/assign`,
    { assignedTo }
  );

export const updateCsrStatus = async (
  id: string,
  status: string,
  notes?: string
) =>
  handlePatchRequest<{ status: string; notes?: string }, CsrTicket>(
    `/csr/${id}/status`,
    { status, notes }
  );
